export default __webpack_public_path__ + "static/media/DSC_0540.6f4d6101.webp";